// extracted by mini-css-extract-plugin
export var avatarBox = "avatar-module--avatar-box--de82c";
export var avatarInnerBox = "avatar-module--avatar-inner-box--bfd42";
export var big = "avatar-module--big--88ab5";
export var border = "avatar-module--border--d6051";
export var dark = "avatar-module--dark--6ba18";
export var huge = "avatar-module--huge--3806f";
export var image = "avatar-module--image--1e17b";
export var large = "avatar-module--large--ae9bd";
export var medium = "avatar-module--medium--0cfaf";
export var shadow = "avatar-module--shadow--a9136";
export var small = "avatar-module--small--1763f";